const initBlock = async function( $block ) {
	const { Swiper } = await import( 'swiper' );
	const { Navigation } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const $slider = $block.find( '.testimonials-slider' );
	const $sliderNav = $block.find( '.section-testimonials__slider-nav' );
	const $buttonNext = $sliderNav.find( '.slider-nav__next' );
	const $buttonPrev = $sliderNav.find( '.slider-nav__prev' );

	const swiperTestimonialsParams = {
		modules: [Navigation],
		navigation: {
			nextEl: $buttonNext[0],
			prevEl: $buttonPrev[0]
		},
		init: false,
		loop: false,
		allowTouchMove: true,
		speed: 750,
		spaceBetween: 12,
		slidesPerView: 1,
		slidesPerGroup: 1,
		breakpoints: {
			641: {
				slidesPerView: 2,
				spaceBetween: 12
			},
			1181: {
				slidesPerView: 3,
				spaceBetween: 20
			}
		}
	};
	const swiperTestimonials = new Swiper( $slider[0], swiperTestimonialsParams );
	swiperTestimonials.init();
};

app.loadBlock( initBlock, 'section-testimonials', '.section-testimonials' );

if ( module.hot ) {
	module.hot.accept();
}
